import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';
import {  GetListBase} from './clearing-house.model';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
  
import { GlobalComponent } from 'src/app/global/global.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorService } from 'src/app/error.service';

@Injectable({
  providedIn: 'root'
})

export class GetHTTPService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent,private ngxService:NgxUiLoaderService,) {
    super();
  }

  public execute(state: GetListBase): void {
    this.getCareList(state).subscribe(x => super.next(x));
    this.ngxService.stop()    
  }
 
  getCareList(state?: GetListBase): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/ClearingHouse/getClearingHouse?", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['chList'],
            count: response['totalCount']
          }
      ))
  }
}
